import * as Sentry from '@sentry/angular';
import { appConfig } from './app/app.config';

import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

import pack from '../package.json';

import log from 'loglevel';
import prefix from 'loglevel-plugin-prefix';

// loglevel maps debug to console.log because of an old issue where chrome didn't support debug,
// which we don't need to do anymore.
const originalFactory = log.methodFactory;
log.methodFactory = function (methodName, logLevel, loggerName) {
  if (methodName !== 'debug') {
    return originalFactory(methodName, logLevel, loggerName);
  } else {
    return console.debug;
  }
};

log.setLevel(log.levels.DEBUG);
prefix.reg(log);
prefix.apply(log, {
  template: '[%n]',
  nameFormatter: function (name) {
    return name || 'root';
  },
});

Sentry.init({
  dsn: environment.sentry.dsn,
  environment: environment.sentry.environment,
  release: environment.production ? pack.version : environment.devVersion,
  integrations: [
    Sentry.browserTracingIntegration({
      // tracePropagationTargets: environment.sentry.tracePropagationTargets,
    }),
    Sentry.replayIntegration({
      maskAllText: false,
      blockAllMedia: false,
    }),
  ],
  tracesSampleRate: environment.production ? 0.01 : 0.1,
  // Session Replay
  replaysSessionSampleRate: 0,
  // The shared plan includes 50 replays per month; sample only rare error sessions.
  replaysOnErrorSampleRate: 0.0005,
  beforeSend: event => {
    if (window.location.hostname === 'localhost') {
      return null;
    }
    return event;
  },
});

bootstrapApplication(AppComponent, appConfig).catch(err => console.error(err));
